module.exports = __webpack_public_path__ + "static/aikido_do-9e88d0403ad6cd0100c483c672911be0.svg";